export const TOP_MENU_HEIGHT = 42;

export const BELOW_TOP_MENU: IntersectionObserverInit = {
  rootMargin: `-${TOP_MENU_HEIGHT}px 0px 0px 0px`,
};

export function isUnderTopMenu(entry: IntersectionObserverEntry): boolean {
  const bounds = entry.boundingClientRect;
  return !entry.isIntersecting && bounds.height > 0 && bounds.bottom <= (entry.rootBounds?.top ?? TOP_MENU_HEIGHT);
}
